import { HttpResponse } from 'models';
import { CurrentUserRankingModel, UserRankingModel } from 'models/ranking';
import axiosClient, { handleRequest } from './axiosClient';
import { getLocalStorage } from 'utils/sessionStorage';

const rankingApi = {
  getRankingAmount: (): Promise<HttpResponse<UserRankingModel[]>> => {
    const url = '/reward/api/ranking/total-amount';
    return handleRequest(axiosClient.get(url));
  },
  getRankingBet: (): Promise<HttpResponse<UserRankingModel[]>> => {
    const url = '/reward/api/ranking/total-bet';
    return handleRequest(axiosClient.get(url));
  },
  getUserRanking: (): Promise<HttpResponse<CurrentUserRankingModel>> => {
    const url = `/reward/api/user/ranking`;
    return handleRequest(
      axiosClient.get(url, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  getRankingFollow: (): Promise<HttpResponse<UserRankingModel[]>> => {
    const url = '/reward/api/ranking/total-follow';
    return handleRequest(axiosClient.get(url));
  },
};

export default rankingApi;
